import React, { useState, useEffect } from 'react';

const LifeAtOmSai = () => {

  const [columns, setColumns] = useState(getColumns(window.innerWidth));

  function getColumns(width) {
    if (width <= 768) return 1; // Mobile
    if (width <= 1024) return 2; // Tablet
    return 2; // Desktop
  }

  useEffect(() => {
    const handleResize = () => {
      setColumns(getColumns(window.innerWidth));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const containerStyle = {
    padding: '40px 20px',
    backgroundColor: '#f8f8f8',
    textAlign: 'center',
  };

  const headingStyle = {
    fontSize: '38px',
    fontWeight: 'bold',
    color: '#000',
    marginBottom: '30px',
  };

  const gridStyle = {
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gap: '20px',
    maxWidth: '1200px',
    margin: '0 auto',
    
  };

  const iframeStyle = {
    width: '100%',
    height: '315px',
    border: 'none',
    borderRadius: '12px',
  };

  return (
    <div style={containerStyle}>
      <h2 style={headingStyle}>Life at OM SAI</h2>
      <div style={gridStyle}>
        <iframe
          style={iframeStyle}
          src="https://www.youtube.com/embed/VIDEO_ID_1"
          title="YouTube video 1"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <iframe
          style={iframeStyle}
          src="https://www.youtube.com/embed/VIDEO_ID_2"
          title="YouTube video 2"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <iframe
          style={iframeStyle}
          src="https://www.youtube.com/embed/VIDEO_ID_2"
          title="YouTube video 2"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>

        <iframe
          style={iframeStyle}
          src="https://www.youtube.com/embed/VIDEO_ID_2"
          title="YouTube video 2"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default LifeAtOmSai;
